import router from '../../router';
import api from '../../api/index';
import ideas from './Activity_ideas';
import live_news from './Activity_live_news';
import suggestions from './Activity_suggestions';

export default {
  namespaced: true,
  modules   : {
    ideas,
    live_news,
    suggestions,
  },
  state: {
    themes: [
      {
        code: 'datas',
        text: 'Оптимизация данных',
      },
      {
        code: 'logistic',
        text: 'Логистика и товарооборот',
      },
    ],
    modals: [
      {
        type  : 'suggest_idea',
        active: false,
      },
      {
        type  : 'suggest_news',
        active: false,
      },
    ],
    tab          : null,
    search_string: '',
  },
  getters: {
    themes       : ({themes}) => themes,
    tab          : ({tab}) => tab,
    search_string: ({search_string}) => search_string,
    current_tab_content({ideas, live_news, suggestions}, {tab='ideas'}) {
      if (tab=='ideas') {
        return ideas;
      } else if (tab=='live-news') {
        return live_news;
      } else if (tab=='suggestions') {
        return suggestions;
      }
    },
    suggest_idea_modal: ({modals}) => modals.find((modal)=> modal.type == 'suggest_idea').active,
    suggest_news_modal: ({modals}) => modals.find((modal)=> modal.type == 'suggest_news').active,
  },
  mutations: {
    CLOSE_MODAL(state, type) {
      let modal = state.modals.find((modal)=> modal.type === type);
      modal.active = false;
    },
    OPEN_MODAL(state, type) {
      let modal = state.modals.find((modal)=> modal.type === type);
      if (!modal.active) {
        modal.active = true;
      }
    },
    SET_ACTIVE_TAB(state, value) {
      state.tab = value;
    },
    TO_LIKED(state, idea) {
      idea.liked = !idea.liked;
      if (idea.liked) {
        idea.likes = parseInt(idea.likes, 10) + 1;
      } else {
        idea.likes = parseInt(idea.likes, 10) - 1;
      }
    },
    SET_THEMES(state, value) {
      state.themes = value.themes;
      state.themes.unshift({code: '0', text: 'Все темы'});
    },
    SEARCH_ACTIVITY(state, value) {
      state.search_string = value;
    },
  },
  actions: {
    async get_activity({commit}) {
      try {
        const activity = await api.activity.get_activity();
        commit('activity/ideas/SET_ACTIVITY_IDEAS', activity.data.ideas, {root: true});
        commit('activity/live_news/SET_ACTIVITY_FEED', activity.data.live_news, {root: true});
        commit('activity/suggestions/SET_ACTIVITY_SUGGESTIONS', activity.data.suggestions, {root: true});
        commit('SET_THEMES', activity.data);
      } catch (err) {
        if (err.message.indexOf('401')!=-1) {
          router.push({name: 'auth'});
          localStorage.clear();
        }
      }
    },
  },
};
